import React, {Component} from 'react';
import $ from 'jquery';
import {Link} from 'react-router-dom';

class TopNavigation extends Component {

    constructor(props){
        super(props)
        this.onItemClick = this.onItemClick.bind(this);
        this.handleNavigation = this.handleNavigation.bind(this);
        this.handleChildLink = this.handleChildLink.bind(this);
        var roles = JSON.parse(localStorage.getItem("roles"));
        this.state = {
            dashboardLinkClass :'collapse in',
            systemSettingClass : '',
            childName:'home',
            roles: roles
        }
    }
    handleNavigation(id){
        if(id==='dashboard'){
            this.setState({dashboardLinkClass:'collapse in'})
            this.setState({systemSettingClass:''})
        }else if(id==='systemSetting'){
            this.setState({dashboardLinkClass:''})
            this.setState({systemSettingClass:'collapse in'})
        }

    }

    handleChildLink(pId,cId){
        if(pId==='dashboard'){
            this.setState({childName:cId})
        }else if(pId==='systemSetting'){
            this.setState({childName:cId})
        }
    }

    componentDidMount(){
        const url = window.location.href;
        let _this = this
        if(url.indexOf("organization") > -1){
            _this.setState({dashboardLinkClass:''})
            _this.setState({systemSettingClass:'collapse in',childName:'orgNav'})
        }else if(url.indexOf("signature/list") > -1){
            _this.setState({dashboardLinkClass:'collapse in',childName:'home'})
            _this.setState({systemSettingClass:''})
        }else if(url.indexOf("esignatureDetail") > -1){
            _this.setState({dashboardLinkClass:'collapse in',childName:'home'})
            _this.setState({systemSettingClass:''})
        }else if(url.indexOf("staff") > -1){
            _this.setState({systemSettingClass:'collapse in',childName:'staffs'})
            _this.setState({dashboardLinkClass:''})
        }else if(url.indexOf("blubillingConfig") > -1){
            _this.setState({systemSettingClass:'collapse in',childName:'blubillingConfig'})
            _this.setState({dashboardLinkClass:''})
        }else if(url.indexOf("signatureSetting") > -1){
            _this.setState({systemSettingClass:'collapse in',childName:'signatureSetting'})
            _this.setState({dashboardLinkClass:''})
        }
        else if(url.indexOf("template") > -1) {
            _this.setState({dashboardLinkClass:'collapse in',childName:'templates'})
            _this.setState({systemSettingClass:''})
        }else if(url.indexOf("htmlTemplate") > -1) {
            _this.setState({dashboardLinkClass:'collapse in',childName:'listHtmlTemplate'})
            _this.setState({systemSettingClass:''})
        }else if(url.indexOf("emailConf") > -1) {
            _this.setState({systemSettingClass:'collapse in',childName:'emailConf'})
            _this.setState({dashboardLinkClass:''})
        }else if(url.indexOf("paymentProcessorConfiguration")>-1) {
            _this.setState({systemSettingClass: 'collapse in', childName: 'paymentProcessorConfiguration'})
            _this.setState({dashboardLinkClass: ''})
        }else if(url.indexOf("payment")>-1 || url.indexOf("processPayment")>-1) {
            _this.setState({dashboardLinkClass: 'collapse in', childName: 'payments'})
            _this.setState({systemSettingClass: ''})
        }
        else{
            _this.setState({dashboardLinkClass:'collapse in',childName:'home'})
            _this.setState({systemSettingClass:''})
        }
    }
    onItemClick(event) {
        if($("body").attr('className').indexOf("mini-navbar") > 0){
            $("body").removeClass('mini-navbar')
        }else{
            $("body").addClass('mini-navbar')
        }
        if (!$('body').hasClass('mini-navbar') || $('body').hasClass('body-small')) {
            // Hide menu in order to smoothly turn on when maximize menu
            $('#side-menu').hide();
            // For smoothly turn on menu
            setTimeout(
                function () {
                    $('#side-menu').fadeIn(400);
                }, 200);
        } else if ($('body').hasClass('fixed-sidebar')) {
            $('#side-menu').hide();
            setTimeout(
                function () {
                    $('#side-menu').fadeIn(400);
                }, 100);
        } else {
            // Remove all inline style from jquery fadeIn function to reset menu state
            $('#side-menu').removeAttr('style');
        }
    }
    render() {

        let _this = this;

        return (
            <div className="row border-bottom white-bg">
                <nav className="navbar navbar-static-top">
                    <div className="navbar-header">
                        <button aria-controls="navbar" aria-expanded="false" data-target="#navbar"
                                data-toggle="collapse" className="navbar-toggle collapsed" type="button">
                            <i className="fa fa-bars"></i>
                        </button>
                        <a className="navbar-brand" title={this.props.organization && this.props.organization.name}>{this.props.organization && this.props.organization.name}</a>
                    </div>
                    { this.props.topNavigationMenu ?
                    <div className="navbar-collapse collapse" id="navbar">
                        <ul className="nav navbar-nav">
                            { this.props.topNavigationMenu.dashboardUrl ?
                                <li className={this.state.childName === 'home' ? 'active' : ''} id="dashboard">
                                    <Link to={this.props.topNavigationMenu.dashboardUrl}
                                       onClick={this.handleChildLink.bind(this, 'dashboard', 'home')}>{_this.props.msg('leftNavigation.dashboard')}</Link>
                                </li>:''
                            }
                            { this.props.topNavigationMenu.templateListUrl ?
                                <li className={this.state.childName === 'templates' ? 'active' : ''} id="templates">
                                    <Link to={this.props.topNavigationMenu.templateListUrl}
                                       onClick={this.handleChildLink.bind(this, 'dashboard', 'templates')}>{_this.props.msg('leftNavigation.templates')}</Link>
                                </li>:''
                            }
                            {(this.props.topNavigationMenu && this.props.topNavigationMenu.htmlTemplateListUrl)  ?
                                <li className={this.state.childName === 'listHtmlTemplate'?'active':''}  id="listHtmlTemplate">
                                    <Link to={this.props.topNavigationMenu.htmlTemplateListUrl} onClick={this.handleChildLink.bind(this,'dashboard','listHtmlTemplate')}>{_this.props.msg('leftNavigation.htmlTemplates')}</Link>
                                </li> : ''
                            }
                            { this.props.topNavigationMenu.getSignatureUrl ?
                                <li className={this.state.childName === 'signatureRequest' ? 'active' : ''}
                                    id="signatureRequest">
                                    <form
                                        action={this.props.topNavigationMenu.getSignatureUrl}
                                        method="post">
                                        <input type="hidden" name="token" value={this.props.jwtToken}/>
                                        <input type="hidden" name="pageUrl" value="/esignature/getSignature"/>
                                        <input type="hidden" name="erpRequest" value="true"/>
                                        <input type="submit" value={_this.props.msg('leftNavigation.getSignature')}
                                               name="Get Signature"
                                               style={{
                                                   padding: '16px 20px',
                                                   fontWeight: '600',
                                                   backgroundColor: 'transparent',
                                                   textDecoration: 'none',
                                                   boxSizing: 'border-box',
                                                   fontFamily: 'sans-serif',
                                                   fontSize: '13px',
                                                   lineHeight: '1.42857143',
                                                   border: '0px',
                                                   textAlign: 'left',
                                                   position: '0px'
                                               }}
                                        />
                                    </form>
                                </li>:''
                            }
                           {/* <li className={this.state.childName === 'signatureRequests'?'active':''} id="signatureRequests">
                                <Link to="/signature/list" onClick={this.handleChildLink.bind(this,'dashboard','signatureRequests')}>{_this.props.msg('leftNavigation.signatureReqList')}</Link>
                            </li>*/}
                            { this.props.topNavigationMenu.paymentListUrl ?
                                <li className={this.state.childName === 'payments' ? 'active' : ''} id="payments">
                                    <Link to={this.props.topNavigationMenu.paymentListUrl}
                                       onClick={this.handleChildLink.bind(this, 'dashboard', 'payments')}>{_this.props.msg('leftNavigation.payments')}</Link>
                                </li>:''
                            }
                            { (this.props.topNavigationMenu && this.props.topNavigationMenu.isShowSystemSetting === true) ?
                                <li className="dropdown">
                                    <a aria-expanded="false" role="button" className="dropdown-toggle"
                                       data-toggle="dropdown">{_this.props.msg('leftNavigation.systemSetting')}<span className="caret"></span></a>
                                    <ul role="menu" className="dropdown-menu">
                                        {this.props.topNavigationMenu.organizationUrl ?
                                            <li className={this.state.childName === 'orgNav' ? 'active' : ''}
                                                id="orgNav">
                                                <Link to={this.props.topNavigationMenu.organizationUrl}
                                                   onClick={this.handleChildLink.bind(this, 'systemSetting', 'orgNav')}>{_this.props.msg('leftNavigation.organization')}</Link>
                                            </li> : ''
                                        }
                                        { this.props.topNavigationMenu.manageUserUrl ?
                                            <li className={this.state.childName === 'staffs' ? 'active' : ''}
                                                id="staffs"><Link
                                                to={this.props.topNavigationMenu.manageUserUrl}
                                                onClick={this.handleChildLink.bind(this, 'systemSetting', 'staffs')}>{_this.props.msg('leftNavigation.viewStaff')}</Link>
                                            </li>:''
                                        }
                                        {(this.props.topNavigationMenu.blubillingConfigUrl)  ?
                                            <li className={this.state.childName === 'blubillingConfig'?'active':''} id="staffs">
                                                <Link  to={this.props.topNavigationMenu.blubillingConfigUrl} onClick={this.handleChildLink.bind(this,'systemSetting','blubillingConfig')}>
                                                    {_this.props.msg('leftNavigation.blubillingConfig')}
                                                </Link>
                                            </li> : '' }
                                        { this.props.topNavigationMenu.emailConfigUrl ?
                                            <li className={this.state.childName === 'emailConf' ? 'active' : ''}
                                                id="emailConf"><Link
                                                to={this.props.topNavigationMenu.emailConfigUrl}
                                                onClick={this.handleChildLink.bind(this, 'systemSetting', 'emailConfiguration')}>{_this.props.msg('leftNavigation.emailConfig')}</Link>
                                            </li> : ''
                                        }
                                        {this.props.topNavigationMenu.signatureSettingUrl ?
                                            <li className={this.state.childName === 'signatureSetting' ? 'active' : ''}
                                                id="signatureSetting">
                                                <Link to={this.props.topNavigationMenu.signatureSettingUrl}
                                                   onClick={this.handleChildLink.bind(this, 'systemSetting', 'signatureSetting')}>{_this.props.msg('leftNavigation.signatureSetting')}</Link>
                                            </li> : ''
                                        }
                                        { this.props.topNavigationMenu.paymentProcessorConfigUrl ?
                                            <li className={this.state.childName === 'paymentProcessorConfiguration' ? 'active' : ''}
                                                id="paymentProcessorConfiguration">
                                                <Link
                                                    to={this.props.topNavigationMenu.paymentProcessorConfigUrl}
                                                    onClick={this.handleChildLink.bind(this, 'systemSetting', 'paymentProcessorConfiguration')}>{_this.props.msg('leftNavigation.paymentProcessorConfig')}</Link>
                                            </li> : ''
                                        }
                                         { this.props.topNavigationMenu.salesforceConfigUrl ?
                                            <li className={this.state.childName === 'salesforceConfiguration' ? 'active' : ''}
                                                id="salesforceConfiguration">
                                                <Link
                                                    to={this.props.topNavigationMenu.salesforceConfigUrl}
                                                    onClick={this.handleChildLink.bind(this, 'systemSetting', 'salesforceConfiguration')}>{_this.props.msg('leftNavigation.salesforceConfig')}</Link>
                                            </li> : ''
                                        }
                                    </ul>
                                </li> : ''
                            }

                        </ul>
                        <ul className="nav navbar-top-links navbar-right">
                            <li>
                                {this.props.organization && this.props.organization.domainPrefix ?
                                    <span><img alt="organization logo" style={{"width": "210px", "height":"53px"}} src={_this.props.logoUrl}/></span> : ''
                                }
                            </li>
                            <li>
                                <a href="" onClick={this.props.onLogoutClick}>
                                    <i className="fa fa-sign-out-alt"></i> Log out
                                </a>
                            </li>
                        </ul>
                    </div>:''
                    }
                </nav>
            </div>
        );
    }

}
export default TopNavigation;



// WEBPACK FOOTER //
// ./src/components/common/TopNavigation.js